import { useMemo } from "react";
import { Table } from "antd";
import { formatCurrencyTwoDec } from "../../../helpers/helpers";

const toNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
};

const SettleDealPreview = ({ breakup }) => {
    const settlements = useMemo(() => {
        return Array.isArray(breakup?.settlements)
            ? breakup.settlements
            : [];
    }, [breakup]);

    const totals = useMemo(() => {
        return settlements.reduce(
            (acc, row) => ({
                investor: acc.investor + toNumber(row.investorPayout),
                karncy: acc.karncy + toNumber(row.karncyPayout),
                business: acc.business + toNumber(row.businessPayout),
                penality: acc.penality + toNumber(row.penalty),
                balance: acc.balance + toNumber(row.balance),
            }),
            {
                investor: 0,
                karncy: 0,
                business: 0,
                penality: 0,
                balance: 0,
            }
        );
    }, [settlements]);

    const columns = useMemo(
        () => [
            {
                title: "Deal ID",
                dataIndex: "dealId",
                key: "dealId",
                width: 120,
            },
            {
                title: "Investor Payout",
                dataIndex: "investorPayout",
                key: "investorPayout",
                align: "right",
                width: 160,
                render: (value) => formatCurrencyTwoDec(value),
            },
            {
                title: "Karncy Fee",
                dataIndex: "karncyPayout",
                key: "karncyPayout",
                align: "right",
                width: 140,
                render: (value) => formatCurrencyTwoDec(value),
            },
            {
                title: "Business Payout",
                dataIndex: "businessPayout",
                key: "businessPayout",
                align: "right",
                width: 160,
                render: (value) => formatCurrencyTwoDec(value),
            },
            {
                title: "Penalty",
                dataIndex: "penalty",
                key: "penalty",
                align: "right",
                width: 120,
                render: (value) => formatCurrencyTwoDec(value),
            },
            {
                title: "Balance",
                dataIndex: "balance",
                key: "balance",
                align: "right",
                width: 140,
                render: (value) => formatCurrencyTwoDec(value),
            },
        ],
        []
    );

    return (
        <div className="settle-preview-container">
            <Table
                dataSource={settlements}
                columns={columns}
                rowKey={(row) => row.dealId}
                pagination={false}
                bordered
                size="middle"
                scroll={{ x: "max-content" }}
                summary={() => (
                    <Table.Summary.Row>
                        <Table.Summary.Cell index={0}>
                            <strong>Total</strong>
                        </Table.Summary.Cell>

                        <Table.Summary.Cell index={1} align="right">
                            <strong>
                                {formatCurrencyTwoDec(totals.investor)}
                            </strong>
                        </Table.Summary.Cell>

                        <Table.Summary.Cell index={2} align="right">
                            <strong>
                                {formatCurrencyTwoDec(totals.karncy)}
                            </strong>
                        </Table.Summary.Cell>

                        <Table.Summary.Cell index={3} align="right">
                            <strong>
                                {formatCurrencyTwoDec(totals.business)}
                            </strong>
                        </Table.Summary.Cell>

                        <Table.Summary.Cell index={4} align="right">
                            <strong>
                                {formatCurrencyTwoDec(totals.penality)}
                            </strong>
                        </Table.Summary.Cell>

                        <Table.Summary.Cell index={5} align="right">
                            <strong>
                                {formatCurrencyTwoDec(totals.balance)}
                            </strong>
                        </Table.Summary.Cell>
                    </Table.Summary.Row>
                )}
            />

            <div style={{ marginTop: 16 }}>
                <strong>Total Transaction Amount: </strong>
                {formatCurrencyTwoDec(breakup?.totalTxnAmt)}
            </div>

            {breakup?.canReleaseBusinessPayout && totals.business > 0 && (
                <div style={{ marginTop: 8 }}>
                    <strong>Business Payout (no other open deals): </strong>
                    {formatCurrencyTwoDec(totals.business)}
                </div>
            )}
            {breakup && breakup.canReleaseBusinessPayout === false && Number(breakup?.unutilizedAmount) > 0 && (
                <div style={{ marginTop: 8 }}>
                    Apply unutilized amount to remaining open deals before releasing Business Payout.
                </div>
            )}
        </div>
    );
};

export default SettleDealPreview;